import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { ShipmentSpecialFreightTrackingFacade } from './shipment-special-freight-tracking.facade';
import { loadStoreState, setInitialStoreState } from '../../../../../common/utils';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ShipmentSpecialFreightItemFacade } from '../shipment-special-freight-item.facade';
import { SpecialFreightIdView } from '../../../../models';

@Injectable({ providedIn: 'root' })
export class ShipmentSpecialFreightTrackingGuard {
  constructor(
    private shipmentSpecialFreightTrackingFacade: ShipmentSpecialFreightTrackingFacade,
    private shipmentSpecialFreightItemFacade: ShipmentSpecialFreightItemFacade,
  ) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return this.shipmentSpecialFreightItemFacade.specialFreightIdentifier$.pipe(
      switchMap((identifier: SpecialFreightIdView) => {
        return loadStoreState(this.shipmentSpecialFreightTrackingFacade, identifier);
      }),
    );
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.shipmentSpecialFreightTrackingFacade);
  }
}
